import React from 'react';
import PropTypes from 'prop-types';
import styles from './sliderArrow.module.scss';

const SliderArrow = ({ isActive }) => (
  <svg
    className={isActive ? styles.cwSliderArrowActive : styles.cwSliderArrow}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="18"
    viewBox="0 0 20 18">
    <path
      d="M19.494 9.50606L20 9.00002L19.494 8.49397L11.9704 0.970462L11.4644 0.464417L10.4523 1.47651L10.9584 1.98255L17.2593 8.28349H0.716525H0V9.71654H0.716525H17.2593L10.9584 16.0175L10.4523 16.5235L11.4644 17.5356L11.9704 17.0296L19.494 9.50606Z"
      fillOpacity="0.8"
    />
  </svg>
);

SliderArrow.propTypes = {
  isActive: PropTypes.bool,
};

export default SliderArrow;
